import { FieldValues, Path, mapRadioCardsField } from '@ninja/utilities';
import { useAppPlatformContextOptions } from '../../../../../contexts/app';

export const useIsWithEidField = <TForm extends FieldValues>() => {
	const { translate: t } = useAppPlatformContextOptions();
	const getField = ({ field }: { field: Path<TForm> }) =>
		mapRadioCardsField({
			field,
			cards: [
				{ id: 0, answerText: t('members:fields.is-with-eid.no') },
				{ id: 1, answerText: t('members:fields.is-with-eid.yes') },
			]?.map((a) => ({
				id: a.id,
				label: a.answerText,
				className: 'bg-white justify-center w-full !py-1.5 sm:px-8 !rounded-md !font-bold',
				center: true,
			})),
			size: 'small',
			direction: 'row',
		});

	return {
		getField,
	};
};
